import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AppSettings } from 'service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import attendance_image from '../../assets/images/attendance.png'
import payslip_image from '../../assets/images/payslip.png'
import profile_image from '../../assets/images/profile.png'
import leave_image from '../../assets/images/leave.png'
import regularization_image from '../../assets/images/regularization.png'
import daily_attendance_image from '../../assets/images/daily_attendance.png'
import notification_image from '../../assets/images/notifications.png'
import todo_image from '../../assets/images/todo.png'
import SettingsService from 'service/SettingsService';
import { ActionCreators } from 'store/actionCreators';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<any>();
    const [company, setCompany] = useState<any>();
    const [settings, setSettings] = useState<AppSettings>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [screenMode, setScreenMode] = useState<string>("main-screen");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (userData.profile) {
            setUser(userData.profile.profile.user);
            setCompany(userData.company);
            setIsLoading(false);

            // Get the server app settings
            SettingsService.get()
                .then((data) => {
                    setSettings(data);
                });
        }
    }, [userData]);

    const changeCompany = () => {
        dispatch(ActionCreators.changeCompany());
    }

    return (
        <>
            <div className="page-dashboard">
                <div className="container">
                    <div className='row'>
                        <div className='page-header card' style={{ paddingBottom: "10px" }}>
                            Welcome,
                            <h2>{user?.name}</h2>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='page-header card' style={{ paddingBottom: "20px" }}>
                            <b>{company?.name}</b>
                            {userData.profile.profile.companies.length > 1 &&
                                <div className="btn btn-sm btn-secondary" style={{ marginTop: "10px" }} onClick={changeCompany}>
                                    Change Company
                                </div>
                            }
                        </div>
                    </div>
                    {isLoading &&
                        <Loader />
                    }
                    {!isLoading &&
                        <>

                            <div className='row'>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/employees">
                                        <div className="card">
                                            <img className="card-img-top" src={profile_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Employees</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/notifications">
                                        <div className="card">
                                            <img className="card-img-top" src={notification_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Notifications</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/todo">
                                        <div className="card">
                                            <img className="card-img-top" src={todo_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">To Do</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance">
                                        <div className="card">
                                            <img className="card-img-top" src={daily_attendance_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Daily Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance/employee">
                                        <div className="card">
                                            <img className="card-img-top" src={attendance_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Employee Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/regularization">
                                        <div className="card">
                                            <img className="card-img-top" src={regularization_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Attendance Regularizations</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/leave">
                                        <div className="card">
                                            <img className="card-img-top" src={leave_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Leaves</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/payslip">
                                        <div className="card">
                                            <img className="card-img-top" src={payslip_image} alt="Card image cap"></img>
                                            <div className="card-body">
                                                <h5 className="card-title">Payslips</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>

                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};